import {
  InsufficientAccessBackground,
  ProjectGanntChartSection,
  ProjectMilestonesHeaderSection,
  StyledActivityCardBackground,
  useAccessState
} from 'modules';

import {
  Outlet,
  useLocation
} from 'react-router-dom';



export type ProjectMilestonesActivityProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const ProjectMilestonesActivity = (props: ProjectMilestonesActivityProps) => {
  const location = useLocation();
  const access = useAccessState('Milestone');

  if (!access.view) {
    return (
      <InsufficientAccessBackground.FC />
    );
  }
  if (!location.pathname.endsWith('milestones')) {
    return <Outlet />;
  }
  return (
    <StyledActivityCardBackground.FC>
      <ProjectMilestonesHeaderSection.FC />
      <ProjectGanntChartSection.FC />
    </StyledActivityCardBackground.FC>
  );
};
